/**
 * 创建人：但志强
 * 时间：2021-06-09
 * 描述：登录页面
 * 更新记录: 
 */
 import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
 import { SwJwtService } from '../librarys/serves/sw-jwt.service';
 import { SwRouteguardService } from '../librarys/serves/sw-routeguard.service';
 import { SwMenuService } from '../librarys/serves/sw-menu.service';
 import { environment } from 'src/environments/environment';
 import { SwLoadingmaskComponent } from '../librarys/components/basic-components/sw-loadingmask/sw-loadingmask.component';
 import { Md5 } from "ts-md5";
 import { SwHttpClientService } from '../librarys/serves/sw-http-client.service';
 import { ConfigurationService } from '../librarys/serves/public/configuration.service';
 import { OninitService } from '../librarys/serves/oninit.service';
 import { SwMassageBoxService } from '../librarys/serves/sw-massage-box.service';
 import { SwLoadingmaskService } from '../librarys/components/basic-components/sw-loadingmask/sw-loadingmask.service';
 import {TranslateService} from '@ngx-translate/core';
 import { SystemIdService } from '../librarys/serves/public/system-id.service';
 import { runInThisContext } from 'vm';
 import { SwMaskService } from '../librarys/components/basic-components/sw-mask/sw-mask.service';
import { ActivatedRoute, Params } from '@angular/router';
 
 declare var $: any;
 @Component({
  selector: 'app-user-auto-login',
  templateUrl: './user-auto-login.component.html',
  styleUrls: ['./user-auto-login.component.css']
})
export class UserAutoLoginComponent implements OnInit {
   msg: string = "";
   loginSystem: string = "";
   loginImage:string = ''
   projectLogo: string = "";
   projectLogoWidth: string = "";
   copyRight:string = '';//版权信息
   systemData:any=[];
   partnerData:any=[];
   loginStyle = environment.loginStyle;
   multiTenancy:boolean; //是否开启多租户管理模式
   closeEye: boolean = true;
   enableSsoLogin:boolean =environment.enableSsoLogin; //是否启用sso登录
 
   defualtlanguage:string='zh-CN';//默认语言
   languages:any = [{id:'zh-CN',text:'中文简体'},{id:'en-US',text:'English'}] //所有语言
   isLanguage:boolean = false; //是否使用切换语言
   isVcode:boolean = true; //是否有验证码功能
   isSlideVerify:boolean = false; //滑动验证码是否通过；默认为false，未通过；true通过
   isSliderCode: boolean = false; //登录界面是否有滑动验证功能,默认不需要滑动验证,值为false
   constructor(
     private _http: SwHttpClientService,
     private init :OninitService,
     private jwt: SwJwtService,
     private config: ConfigurationService, //初始化配置文件
     private swMenus: SwMenuService,
     private box: SwMassageBoxService,  //消息提示服务
     private swRouter: SwRouteguardService,
     private systemId:SystemIdService,
     private swLoadingmaskService:SwLoadingmaskService,  //过渡效果
     public translateService: TranslateService,
     private routeInfo: ActivatedRoute,
     private swMaskService: SwMaskService
     ) {
       this.defualtlanguage = environment.defaultLanguage
       if(environment.defaultLanguage){
         this.isLanguage = true;
       }
       this.isSliderCode = environment.isSliderCode
      }
   @ViewChild("loading") loading: SwLoadingmaskComponent;
   ngOnInit() {
    // 获取路由参数
    this.routeInfo.queryParams.subscribe((data: Params) => {
      const authorizationu = data['authorizationu'];
      this.entryLogin(authorizationu);
      console.log('进来啦....');
      console.log(authorizationu);
    });
   }
 
   //登录接口
   entryLogin(authorizationu){
      let systemId = environment.kgsSystemId;
      this.init.GC(); // 清除缓存，工作台和路由复用
      this.jwt.setToKen("language",this.defualtlanguage); //登录成功后将当前语言设置存进缓存
      this.jwt.setToKen("token", authorizationu); //添加新的token
      this.jwt.removeItem("TabMenu"); //添加新的工作台
      this.jwt.setToKen("systemId", systemId);
      this.swMenus.location('login');
   }
 }
 
 
 
 
 
 
 
